module.exports = __webpack_public_path__ + "static/media/motel-los-pinos-logo.bb7fe8f8.png";